/**
 * Botón para cambiar entre tema claro y oscuro.
 *
 * Muestra el icono de lo que va a pasar al pulsarlo, no el del estado actual:
 * en claro se ve la luna ("cambiar a oscuro"). Es lo que espera cualquiera que
 * ya haya usado el interruptor de otra aplicación.
 *
 * Es el mismo botón en la tienda y en el backoffice —el tema es uno solo, vive
 * en el `data-theme` del documento— y por eso lo único que cambia es la clase:
 * en la cabecera va sobre fondo claro y en la barra lateral sobre el azul
 * oscuro. Duplicar el componente para cambiarle el color habría duplicado
 * también la lógica del tema.
 */
import { useTema } from '../../hooks/use-tema';
import { Icono } from '../comunes/Icono';

export interface BotonTemaProps {
  className?: string;
}

export function BotonTema({ className = 'btn-icono' }: BotonTemaProps) {
  const { tema, alternar } = useTema();
  const aOscuro = tema === 'claro';

  return (
    <button
      type="button"
      className={className}
      onClick={alternar}
      aria-pressed={!aOscuro}
      aria-label={aOscuro ? 'Cambiar a tema oscuro' : 'Cambiar a tema claro'}
      title={aOscuro ? 'Cambiar a tema oscuro' : 'Cambiar a tema claro'}
    >
      <Icono nombre={aOscuro ? 'luna' : 'sol'} />
    </button>
  );
}
